// client/src/pages/landingpages/DataPage.js
import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SmartDataTable from '../../components/SmartDataTable';
import { useOrg } from "../orgs/org-context";

export default function LandingPagesDataPage() {
  const navigate = useNavigate();
  const [tableKey, setTableKey] = useState(0);
  const { activeOrgId, activeOrg } = useOrg();
  const orgId =
    activeOrgId ||
    activeOrg?._id ||
    (typeof window !== "undefined" && localStorage.getItem("activeOrgId")) ||
    "none";


  // When active org changes, remount the table to force a fresh fetch
  useEffect(() => {
    setTableKey((k) => tableKey + 1);
  }, [orgId]);


  const columns = useMemo(
    () => [

      {
        value: 'name',
        width: '5%',
        align: 'center',
        type: 'count'
      },
      {
        value: 'name',
        label: 'Name',
        width: 220,
        search: 'name'
      },
      {
        value: 'description',
        label: 'Description',
        width: 420,
        search: 'description'
      }

    ],
    []
  );

  const config = useMemo(
    () => ({
      columns,
      queryName: '/landingpages/list',
      pageSize: 20,
      pageTitle: 'Landing Pages',
      onAddNew: '/lpages/edit/add',
      deletePathTemplate: '/landingpages/delete/{_id}',
      deleteMethod: 'POST',
    }),
    [columns]
  );

  return (
    <div className="datatable-page">
      <div className="datatable-header-row" style={{ justifyContent: 'space-between' }}>
        <div style={{ fontSize: 18, fontWeight: 700, paddingLeft: 20 }}>Landing Pages</div>
      </div>

      <SmartDataTable
        key={tableKey}                    // remount on org change
        config={{
          ...config,
          buttons: [
            { label: 'Edit', color: 'green', action: '/lpages/edit/{_id}' },
            { label: 'Copy', color: 'blue', requestPath: '/landingpages/copy/{_id}' },
            { label: 'Delete', color: 'red', action: 'delete' },
          ],
        }}
      />
    </div>
  );
}
